import { withTable } from "slate-table";
import { Editor, Element, Node, Transforms } from "slate";
export const withTables = (editor) => {
    const editorWithTable = withTable(editor, {
        blocks: {
            table: "table",
            thead: "table-head",
            tbody: "table-body",
            tfoot: "table-footer",
            tr: "table-row",
            th: "table-header-cell",
            td: "table-cell",
            content: "paragraph"
        },
        withDelete: true,
        withFragments: true,
        withInsertText: true,
        withNormalization: true,
        withSelection: true,
        withSelectionAdjustment: true
    });
    const { normalizeNode } = editorWithTable;
    editor.normalizeNode = ([node, path]) => {
        if (Element.isElement(node) && node.type === "table") {
            // Ensure tables have a paragraph element above and below them to avoid selection / new line / "Enter" key bugs
            const nextLinePath = [path[0] + 1];
            const nodeAtNextLine = path[0] < editor.children.length - 1 && Node.get(editor, nextLinePath);
            const needsParagraphAfter = !nodeAtNextLine || !Element.isElement(nodeAtNextLine) || !Editor.isBlock(editor, nodeAtNextLine);
            if (needsParagraphAfter) {
                Transforms.insertNodes(editor, { type: "paragraph", children: [{ text: "" }] }, { at: nextLinePath });
            }
        }
        // Run original `normalizeNode` to enforce other constraints
        normalizeNode([node, path]);
    };
    return editorWithTable;
};
